<template>
  <el-dialog
      :title="list.productName"
      :visible.sync="visible"
      width="500px"
      :before-close="handleClose">

    <el-descriptions title="商品信息" :class="type === 'rsa' ? 'rsa' : 'timeStamp'" v-loading="loading"
                     :column="type === 'rsa' ? 3 : 1">
      <el-descriptions-item label="商品名">{{ list.productName }}</el-descriptions-item>
      <el-descriptions-item label="价格" v-if="type === 'rsa'">{{ list.productPrice }} 元</el-descriptions-item>
      <el-descriptions-item label="价格" v-if="type === 'timeStamp'">{{ list.productPrice }} 元/次
      </el-descriptions-item>
      <el-descriptions-item label="使用次数">
        <el-input-number v-model="payList.buyCount" :step="1" step-strictly :min="1" size="mini"></el-input-number>
        次
      </el-descriptions-item>
      <el-descriptions-item label="说明" class="remark">{{ list.remark }}
      </el-descriptions-item>
    </el-descriptions>

    <span slot="footer" class="dialog-footer">
      <el-button @click="updateDialog(false)">取 消</el-button>
      <el-button type="primary" @click="handleSubmit('wxpay')">微信支付</el-button>
      <el-button type="primary" @click="handleSubmit('alipay')">支付宝支付</el-button>
    </span>

    <pay-dialog
        v-if="payVisible"
        :visible.sync="payVisible"
        :payList="payList"
        :type="payList.payType"
        @closeAll="closeAll"/>

  </el-dialog>
</template>

<script>

import PayDialog from "@/pages/userCenter/components/payDialog.vue";

export default {
  name: "copies-details",
  components: {PayDialog},
  data() {
    return {
      list: {},
      visible: false,
      payVisible: false,
      loading: false,
      userId: null,
      type: null,
      payList: {
        buyCount: 1,
      }
    };
  },
  computed: {
    user() {
      return this.$store.state.account.user
    },
    isLogin() {
      return this.user && this.user.userId
    }
  },
  mounted() {
    this.userId = this.$auth.getUserId() || this.user.userId
  },
  methods: {
    handleSubmit(type) {
      this.payList.payType = type
      this.payList.productId = this.list.productId
      this.payList.userId = this.userId
      this.payVisible = true
    },
    open() {
      this.loading = true
      this.visible = true
      this.getProductsInfo()
    },
    getProductsInfo() {
      let params = {
        productType: 'copies',
        type: 'service',
      }
      this.$http.post(this.$api.register.getProductsInfo, params).then(res => {
        if (res.data.code == 200) {
          if (res.data.data.length > 0) {
            this.list = res.data.data[0]
          } else {
            this.$message.error('暂无商品信息')
          }
          this.loading = false
        } else {
          this.$message.error(res.data.msg)
          this.loading = false
        }
      });
    },
    closeAll() {
      this.visible = false
      this.payVisible = false
    },
    handleClose() {
      this.updateDialog(false)
    },
    /* 更新visible */
    updateDialog(value) {
      this.visible = value
      // this.$emit('update:visible', value);
    }
  }
}
</script>

<style scoped lang="less">

</style>
